import { AxiosError } from 'axios';
import qs from 'query-string';
import { useInfiniteQuery } from 'react-query';
import { GetConversationMessagesResponse } from '../types';
import axiosClient from '../utils/axiosClient';

export const useInfiniteConversation = (
  id: number | string,
  resultsPerPage: number = 20
) => {
  return useInfiniteQuery<GetConversationMessagesResponse, AxiosError<any>>(
    ['conversation', 'messages', id],
    async ({ pageParam }) => {
      const query: Record<string, any> = {
        limit: resultsPerPage,
        lastMessageId: pageParam || undefined,
      };

      const data = await axiosClient.get<GetConversationMessagesResponse>(
        `/conversation/get/${id}/messages?${qs.stringify(query)}`
      );
      return data.data;
    },
    {
      staleTime: Infinity,
      getPreviousPageParam: (lastPage) => {
        return lastPage.hasMore ? lastPage.messages.at(-1)?.id : undefined;
      },
      // enabled: false,
      keepPreviousData: true,
    }
  );
};
